export default __webpack_public_path__ + "static/media/david-post.2c01daf6.svg";